/**
 * useMembershipTemplates.ts
 *
 * Cached fetch of the grouped `/memberships` payload used by the patient
 * sidebar. Returns the raw response body ({ data: groups, meta, links }),
 * which `normalizePatientMemberships` expects.
 *
 * NOTE: This query MUST NOT share its cache key with `listTemplates()` from
 * `services/memberships.service.ts`, because that function returns a flat
 * `MembershipTemplate[]`, an incompatible shape. Sharing keys would poison
 * downstream `useMemo(() => templates.filter(...))` consumers.
 */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/services/apiClient';

export const MEMBERSHIP_TEMPLATES_QUERY_KEY = ['patient-sidebar-memberships-grouped'] as const;

export function useMembershipTemplates() {
  return useQuery({
    queryKey: MEMBERSHIP_TEMPLATES_QUERY_KEY,
    queryFn: async () => {
      const r = await apiClient.get('/memberships');
      return r.data;
    },
    staleTime: Infinity,
    gcTime: 30 * 60_000,
  });
}
